export default "__VITE_ASSET__XY72ytDd__"